import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const usePaymentLinkPaymentStatusRefresh = (code: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      apiV2Request({
        method: "post",
        path: `payment-link/ref/${code}/refresh-payment-status`,
        business: null,
      }),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [ServerStateKeys.PaymentLink, "ref", code],
      }),
  });
};
